export const getClosestValueFromArray = (value: number, array: number[]) => {
  return array.reduce((a, b) => (b <= value && a < b ? b : a), 0);
};
